import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable, BehaviorSubject} from 'rxjs/Rx';
import {environment} from '../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { EventEmitter } from 'events';

@Injectable()
export class BenchmarkService {

  public benchmarksData = new BehaviorSubject([]);
  constructor(private http: Http) {
  }

  getBenchmarks() {
    return this.benchmarksData;
  }

  setBenchmarks(ruid): Observable<any> {
    return this.http.get(`${environment.baseURL}${environment.reportChart}/benchmarks?ruid=${encodeURIComponent(ruid)}`)
      .map((res: Response) => {
        const json = res.json();
        this.benchmarksData.next(<any>json);
        return json;
      });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/benchmarks/benchmarks.service.ts